export function formatNumber(n) {
    const integerPart = Math.floor(n).toString(10);
    const floatPart = Math.abs(Math.round((n - integerPart) * 100)).toString(10);
    let intPartFinal = '';
    let nextIdx;
    if ((integerPart.length % 3) === 0) {
        nextIdx = 3;
        intPartFinal = integerPart.substring(0, nextIdx);
    }
    else {
        nextIdx = integerPart.length % 3;
        intPartFinal = integerPart.substring(0, nextIdx);
    }

    for(let i = nextIdx; i < integerPart.length; i+= 3) {
        intPartFinal += ' ' + integerPart.substring(i, i + 3);
    }

    if (Math.floor(n) === n) {
        return intPartFinal;
    }
    else {
        return `${intPartFinal},${floatPart}`;
    }
}
